namespace RedBullMOBILE360.Settings {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Settings.ServiceParametersGrid')
    export class ServiceParametersGrid extends Serenity.EntityGrid<ServiceParametersRow, any> {
        protected getColumnsKey() { return ServiceParametersColumns.columnsKey; }
        protected getDialogType() { return ServiceParametersDialog; }
        protected getIdProperty() { return ServiceParametersRow.idProperty; }
        protected getInsertPermission() { return ServiceParametersRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceParametersRow.localTextPrefix; }
        protected getService() { return ServiceParametersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}